import * as R from 'ramda'
import {
    ADD_SAVED_LISTS_NOTIFICATION_SUCCESS,
    ADD_SAVED_LISTS_NOTIFICATION_START
} from '../actionTypes'

const InitialState = {};

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case ADD_SAVED_LISTS_NOTIFICATION_START:
            return InitialState

        case ADD_SAVED_LISTS_NOTIFICATION_SUCCESS:
            console.log(payload)
            let data = state[payload.id] ? state[payload.id] : {}

            const obj = { ...state, [payload.id] : {...data, ...payload.data}}

            return obj

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/savedListsNotification.js